import { render } from "./RotateTrim.vue?vue&type=template&id=a4b22a8c&scoped=true"
import script from "./RotateTrim.vue?vue&type=script&lang=js"
export * from "./RotateTrim.vue?vue&type=script&lang=js"

import "./RotateTrim.vue?vue&type=style&index=0&id=a4b22a8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b22a8c"]])

export default __exports__